import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=39b4570d&scoped=true"
import script from "./CopyIcon.vue?vue&type=script&lang=js"
export * from "./CopyIcon.vue?vue&type=script&lang=js"
import style0 from "./CopyIcon.vue?vue&type=style&index=0&id=39b4570d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b4570d",
  null
  
)

export default component.exports